import { Link } from 'react-router-dom';
import { hotComics } from '@/mocks/comics';

export default function HotComics() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            精选全网最受欢迎的韩漫佳作，每一部都值得细细品味
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotComics.map((comic, idx) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group block bg-background-100 rounded-lg overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                {idx === 0 && (
                  <span className="absolute top-3 left-3 bg-primary-500 text-white text-xs font-medium px-2.5 py-1 rounded-md whitespace-nowrap">
                    编辑推荐
                  </span>
                )}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                  <span className="text-white text-xs font-medium">
                    {comic.status}
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4 text-center">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-1 truncate">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-2">
                  {comic.author} · 共{comic.chapters}话
                </p>
                <div className="flex items-center justify-center gap-1">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <span className="text-xs font-medium text-accent-600">{comic.rating}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}